import { EnumHelper } from '../shared/enums/enum.helper'
import { VSPDay_Type, VSPDoctor_Type, VSPShift_Type, VSPWeek_Status } from '../shared/services/ppv.api'

export const dayTypes = {
   [VSPDay_Type.NotSet]: 'Not Set',
   [VSPDay_Type.Working]: 'Working',
   [VSPDay_Type.ScheduledDayOff]: 'No Shift Scheduled / Scheduled Time Off',
   [VSPDay_Type.PTO]: 'PTO',
   [VSPDay_Type.Sick]: 'Sick',
   [VSPDay_Type.OtherTimeOff]: 'Other Time Off',
   [VSPDay_Type.LeaveOfAbsence]: 'Leave Of Absence',
   [VSPDay_Type.CE]: 'Continuing Education',
   [VSPDay_Type.LendAHandShift]: 'Lend-a-Hand Shift',
   [VSPDay_Type.VetLifeDay]: 'Vet-Life Day',
   [VSPDay_Type.Remove]: 'Remove Provider / Error',
   [VSPDay_Type.COSA_Duties]: 'COSA Duties',
}

export const dayTypesShort = {
   [VSPDay_Type.NotSet]: 'Not Set',
   [VSPDay_Type.Working]: 'Working',
   [VSPDay_Type.ScheduledDayOff]: 'Scheduled Day Off',
   [VSPDay_Type.PTO]: 'PTO',
   [VSPDay_Type.Sick]: 'Sick',
   [VSPDay_Type.OtherTimeOff]: 'Other Time Off',
   [VSPDay_Type.LeaveOfAbsence]: 'Leave Of Absence',
   [VSPDay_Type.CE]: 'Continuing Education',
   [VSPDay_Type.LendAHandShift]: 'Lend-a-Hand Shift',
   [VSPDay_Type.VetLifeDay]: 'Vet-Life Day',
   [VSPDay_Type.Remove]: 'Remove',
   [VSPDay_Type.COSA_Duties]: 'COSA Duties',
}

export const shiftTypes = {
   [VSPShift_Type.Appts]: 'Appts',
   [VSPShift_Type.Surgery]: 'Surgery',
   [VSPShift_Type.EMGUrgent]: 'EMG/Urgent',
   [VSPShift_Type.OnCall]: 'On Call',
   [VSPShift_Type.Admin]: 'Admin',
   [VSPShift_Type.COSAdmin]: 'COS Admin',
   [VSPShift_Type.RemoteAdmin]: 'Remote Admin',
   [VSPShift_Type.HalfDayPTO]: '1/2 Day PTO',
   [VSPShift_Type.HalfDaySick]: '1/2 Day Sick',
}

export const timeLessShiftTypes = [VSPShift_Type.OnCall, VSPShift_Type.HalfDayPTO, VSPShift_Type.HalfDaySick]

export const doctorTypes = {
   [VSPDoctor_Type.Employee]: 'Employee',
   [VSPDoctor_Type.LendAHand]: 'Lend-A-Hand',
   [VSPDoctor_Type.Relief]: 'Relief',
}

export const weekStatuses = {
   [VSPWeek_Status.Incomplete]: 'Incomplete',
   [VSPWeek_Status.Confirmed]: 'Confirmed',
   [VSPWeek_Status.Submitted]: 'Submitted',
}

type EnumValueLabel = {
   value: number
   label: string
}

export const enumToValueLabelArray = (enumObj: any): EnumValueLabel[] => {
   return Object.keys(enumObj).map((key) => {
      return {
         value: +key,
         label: enumObj[key],
      } as EnumValueLabel
   })
}

export const isTimelessShiftType = (t: VSPShift_Type) => {
   return timeLessShiftTypes.some((st) => st == t)
}

export const needsWorkingShift = (t: VSPShift_Type) => {
   return timeLessShiftTypes.some((st) => st == t && st != VSPShift_Type.OnCall)
}
